const initialState = {};

const ACTION_HANDLERS = {};

export const client = (state = initialState, action) => {
  return ACTION_HANDLERS[action.type]
    ? ACTION_HANDLERS[action.type](state, action)
    : state;
};
